import React from 'react';
import hr from "../assets/hr-app-landing2.PNG";
import portfolio from "../assets/daisyui_website.png";
import webplayer from "../assets/web-music-player2.PNG";
import personalportfolio from "../assets/personal-portfolio2.PNG";

const skillBg = {
  backgroundColor: 'var(--about-bg)'
}
const Portfolio = (props) => {

  const [darkToggle, setDarkToggle] = React.useState(false)
  return (
    <section className={`w-full flex flex-col gap-4 px-4 py-16 glass`} id={props.id}>


      <div className='card shadow-2xl text-center flex mx-auto justify-center lg:flex-column w-full rounded glass'>
        <div className='rounded' style={skillBg}>
          <h2 className="p-5 text-4xl font-bold text-white">
            Portfolio.
          </h2>
          <p className="font-bold text-white">
            My Masterpiece Collection.
          </p>
        </div>
      </div>


      <div className="flex flex-col justify-evenly md:flex-row gap-4">
        <div className="card text-white card-compact w-11/12 md:w-1/3 bg-blue-300 shadow-xl mx-auto">

          <div className="card-body">
            <h2 className="card-title p-2 text-2xl">
              Web Music Player
            </h2>
            <img src={webplayer} alt="Portfolio" />
            <p className="p-2 text-xl">
              Interactive web music player to showcase my skills in software development. Project built with HTML, CSS and Javascript.
            </p>
            <div className="card-actions justify-end">
              <a
                href="https://web-music-player-lilac.vercel.app/"
                className="btn bg-lg bg-green-800 rounded p-2 text-white"
                target="_blank"
              >
                Live Demo
              </a>
            </div>
          </div>
        </div>

        <div className="card text-white card-compact w-11/12 md:w-1/3 bg-blue-300 shadow-xl mx-auto">

          <div className="card-body">
            <h2 className="card-title p-2 text-2xl">
              Personal Portfolio Website
            </h2>
            <img src={personalportfolio} alt="Portfolio" />
            <p className="p-2 text-xl">
              Responsive portfolio website to showcase my skills in web development. Project was built using HTML, CSS and Javascript.
            </p>
            <div className="card-actions justify-end">
              <a
                href="https://personal-portfolio-eta-green.vercel.app/"
                className="btn bg-lg bg-green-800 rounded p-2 text-white"
                target="_blank"
              >
                Live Demo
              </a>
            </div>
          </div>
        </div>

        <div className="card card-compact w-11/12 md:w-1/3 text-white bg-blue-300 shadow-xl mx-auto">

          <div className="card-body">
            <h2 className="card-title p-2 text-2xl">HR App</h2>
            <a href=""></a>
            <img src={hr} alt="hrApp" />
            <p className="p-2 text-xl">
              HR application for managing employees. Features: edit, add, view
              and search employee by details. Built using angular, tailwind c
              ss, mongodb and node(express).
            </p>
            <div className="card-actions justify-end">
              <a
                href="https://hr-app-silk.vercel.app/home" target="_blank"
                className="btn bg-lg bg-green-800 rounded p-2 text-white"
              >
                Live Demo
              </a>
            </div>
          </div>
        </div>

      </div>
    </section>
  )
}

export default Portfolio;